import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config/config.service';
import { HttpErrorService } from './http-error.service';
import { Observable, of } from 'rxjs';
import { TenancyConfiguration } from '../app.types';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TenancyConfigurationService {
  /**
   * CTOR
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {HttpErrorService} httpErrorService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private httpErrorService: HttpErrorService
  ) {}

  getTenancyConfiguration(tenantId: string): Observable<TenancyConfiguration> {
    const url = `${this.configService.CEL_API_URI}/incidents/configuration/internal/${tenantId}`;

    return this.http.get<TenancyConfiguration>(url).pipe(
      map((res) => {
        return res;
            }),
            catchError((err) => {
              this.httpErrorService.handleHttpError(err);
              return of(err);
            })
          );
    }
}
